// import { LoginRequest, LoginResponse, LoginWithExternalProviderRequestAuthProviderEnum, SignupRequest, User } from "@api/entities";
import { LoginRequest, LoginResponse, User } from "src/api/entities";
import { AuthApiClients, IAuthApiClients } from "./auth.api.client";

export interface IAuthApiService {
  login(email: string, password: string): Promise<User>;
  getUserById(id: number): Promise<User>;
  getUserByUID(uid: string): Promise<User>;
  getUserByEmail(email: string): Promise<User>;
  editName(id: number, firstName: string, lastName: string): Promise<User>;
  check(): Promise<User>;
  logout(): Promise<void>;
}
export class AuthApiService implements IAuthApiService {
  protected static instance: IAuthApiService;
  protected api: IAuthApiClients;

  protected constructor(basePath: string) {
    this.api = AuthApiClients.getInstance(basePath);
  }
  static getInstance(basePath: string) {
    if (AuthApiService.instance == null) {
      AuthApiService.instance = new AuthApiService(basePath);
    }
    return AuthApiService.instance;
  }
  async login(email: string, password: string): Promise<User> {
    const loginRequest: LoginRequest = {
      email,
      password,
    };
    const loginResponse: LoginResponse = (
      await this.api.auth.login(loginRequest)
    ).data;
    const user: User = await this.getUserById(loginResponse.id!);
    return user;
  }

  async check(): Promise<User> {
    const checkResponse: LoginResponse = (await this.api.auth.check()).data;
    const user: User = await this.getUserById(checkResponse.id!);
    return user;
  }

  async getUserById(id: number): Promise<User> {
    const user = await this.api.user.getbyId(id)
    return (user).data;
  }

  async getUserByUID(uid: string): Promise<User> {
    const user = await this.api.user.getByUID(uid)
    return (user).data;
  }

  async getUserByEmail(email: string): Promise<User> {
    const user = await this.api.user.getByEmail(email)
    return (user).data;
  }

  async editName(
    id: number,
    firstName: string,
    lastName: string
  ): Promise<User> {
    let firstNameInitial = (firstName.trimLeft()[0] || "").toUpperCase();
    let lastNameInitial = (lastName.trimLeft()[0] || "").toUpperCase();
    const requestPatch: any = [
      {
        op: "replace",
        path: "/data/details/firstName",
        value: firstName,
      },
      {
        op: "replace",
        path: "/data/details/lastName",
        value: lastName,
      },
      {
        op: "replace",
        path: "/data/details/initials",
        value: firstNameInitial + lastNameInitial,
      },
    ];
    const user: User = (await this.api.user.patchUser(id, requestPatch)).data;
    return user;
  }

  async logout(): Promise<void> {
    await this.api.auth.logoff();
  }
  
}
